export default __webpack_public_path__ + "static/home4-98f2228a907994cf3761eb8acf9b9791.jpg";